import { render, staticRenderFns } from "./getMessageView.vue?vue&type=template&id=3d55467e&scoped=true&"
import script from "./getMessageView.vue?vue&type=script&lang=js&"
export * from "./getMessageView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d55467e",
  null
  
)

export default component.exports